// eslint-disable-next-line no-unused-vars
import Node from '@/models/Node';
import { PacketType } from '@/models/Packet';
import StringPacking from '@/models/StringPacking';
import Mutations from '@/store/mutations';
import store from '@/store/store';
import { NodeCreateRequest, NodeHandlers } from './generated/Node';
import { SendPacket } from './SendPacket';

export default class NodeRequests 
{
    static get raw() 
    {
        return NodeHandlers;
    }

    static async CreateNode(timelineid: number, title: string, start: Date, end: Date, description: string | undefined = undefined) : Promise<Node | null>
    {
        const req = Object.assign(new NodeCreateRequest, { title, timelineid, description, start: start.valueOf(), end: end.valueOf() });
        const id = await NodeHandlers.CreateNodeRequest(req);
        if (id == -1) return null;
        
        const node = (store.state as any).project.nodes.get(id);
        if (node)
        {
            const timeline = (store.state as any).project.timelines.get(timelineid);
            timeline.patchEventOrdering(node);
        }
        return node;
    }

    static async CreateNodeRaw(node: Node, timelineid: any) 
    {
        const id = await NodeHandlers.CreateNodeRequest({
            title: node.getTypeChar() + node.name,
            description: StringPacking.Compress(node.description, node.references),
            start: node.dateStart.valueOf().toString(),
            end: node.dateEnd.valueOf().toString(),
            dateOptions: node.dateOptions.valueOf(),
            image: node.image,
            imageCaption: node.imageCaption,
            audio: node.audio,
            important: node.important,
            timelineid: timelineid,
            video: node.video,
            tagIds: node.tags.map(tag => tag.tagid),
            data: JSON.stringify(node.data),
        });

        if (id == -1) return null;

        console.log(`Created node ${id}`);

        let result = (store.state as any).project.nodes.get(id);

        // Wait up to 1 second for the node to be created
        for (let i = 0; i < 10 && !result; ++i) 
        {
            // Wait for 100ms
            await new Promise((resolve, reject) => setTimeout(resolve, 100));
            result = (store.state as any).project.nodes.get(id);
        }
        console.log(`Node obj for ${id} == ${result}`);

        const created = (store.state as any).project.nodes.get(id);
        if (created)
        {
            const timeline = (store.state as any).project.timelines.get(timelineid);
            timeline.patchEventOrdering(created);

            if (node.isEra() && node.color)
            {
                store.commit(Mutations.updateNodeColor, { nodeid: created.nodeid, color: node.color });
                SendPacket(PacketType.NodeUpdateColor, { nodeid: created.nodeid, color: node.color });
            }
        }
        return created;
    }
}